<template>
	<component :is="fieldWrapper" :module="module" v-model="value">
		<div class="input-container">
			<div class="input-title">Super Defined</div>
			<div class="input-box"><input v-model="value.specific_data" type="text"></div>
		</div>
	</component>
</template>

<script>

import FieldMixin from './mixins/FieldMixin';
import StandardField from './StandardField';
import StandardCuratedModuleField from './StandardCuratedModuleField';

export default {

	mixins: [FieldMixin],

	props: {
		module: {
			type: Object,
			default: () => ({}),
		},
	},

	computed: {

		fieldWrapper() {
			if (this.module.is_curated_module) {
				return StandardCuratedModuleField;
			}

			return StandardField;
		}
	}

};

</script>
